export const getIsFormFieldViewOnly = (viewOnlyFields: string[] | undefined, name: string | string[]): boolean => {
  return (viewOnlyFields ?? []).some((el) => el === name || el === (Array.isArray(name) ? name[0] : name.split('.')[0]))
}
